import { updateClientCache } from 'config/api';
import { Notification } from 'notification/notification';
import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { handleSendGeneric } from 'services/generic';

export const ModalVisitRecord = (args) => {
  const { data, setChangeColor } = args;
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const handleRegisterVisit = async (state) => {
    await handleSendGeneric(
      `/v1/client/state/` + data.id + `/` + state,
      'POST'
    );
    setChangeColor({
      background:
        state === 'VISITED'
          ? 'green'
          : state === 'COME_BACK_LATER'
          ? 'yellow'
          : 'white',
      color: state === 'VISITED' ? 'white' : 'black',
    });
    Notification(200, 'Registro realizado com sucesso!');
    updateClientCache(state, data);
  };

  return (
    <div>
      <Button
        color='primary'
        onClick={toggle}
        size='lg'
        style={{ whiteSpace: 'nowrap' }}
        block
      >
        Registrar Visita
      </Button>
      <Modal isOpen={modal} toggle={toggle} {...args}>
        <ModalBody
          style={{
            justifyContent: 'center',
            marginTop: '10%',
            display: 'flex',
          }}
        >
          <div
            style={{
              justifyContent: 'center',
              alignContent: 'center',
            }}
          >
            <h3>Registrar Visita</h3>
            <div
              style={{
                marginTop: '20px',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Button
                color='success'
                onClick={() => handleRegisterVisit('VISITED')}
                size='lg'
                style={{ whiteSpace: 'nowrap' }}
                block
              >
                Visitado
              </Button>
              <Button
                color='warning'
                size='lg'
                onClick={() => handleRegisterVisit('COME_BACK_LATER')}
                style={{ whiteSpace: 'nowrap' }}
                block
              >
                Voltar mais tarde
              </Button>
              <Button
                color='info'
                onClick={() => handleRegisterVisit('UNVISITED')}
                size='lg'
                style={{ whiteSpace: 'nowrap' }}
                block
              >
                Limpar
              </Button>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color='secondary' onClick={toggle}>
            Fechar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};
